import { observer } from "mobx-react-lite";

import { TOP_BANNER } from "../../config";
import { userStore } from "../../stores/userStore";

import "./TopBanner.css";

export const TopBanner = observer(function TopBanner() {
  const DEV_SHOW_BANNER =
    import.meta.env.DEV && import.meta.env.VITE_SHOW_BANNER === "true";
  // const DEV_SHOW_BANNER = true;

  const isExpired = new Date() > new Date(TOP_BANNER.endsAt);
  if (isExpired && !DEV_SHOW_BANNER) return null;

  const sub = userStore.subscription;
  const plan = sub?.team_plan || sub?.plan;
  if (plan && TOP_BANNER.hiddenForPlans.includes(plan) && !DEV_SHOW_BANNER)
    return null;

  const region = userStore.isRuRegion ? "ru" : "en";
  const imgSrc = TOP_BANNER.images[region] ?? TOP_BANNER.images["en"];
  const href = TOP_BANNER.link[region] ?? TOP_BANNER.link["en"];
  const alt = TOP_BANNER.alt[region] ?? TOP_BANNER.alt["en"];

  return (
    <div className="top-banner" style={{ height: TOP_BANNER.height }}>
      <img src={imgSrc} alt={alt} className="top-banner__img" />
      <a
        href={href}
        target="_blank"
        rel="noreferrer"
        className="top-banner__link"
        aria-label={alt}
      />
    </div>
  );
});
